<template>
  <el-card class="filesearchList" :body-style="treeCard" v-show="sonVisible">
    <div class="topBox">
      <el-button type="primary" @click="backsearch">
        <h-icon icon="icon-shangyi" rotate="-90"></h-icon>
        返回上一级</el-button
      >
    </div>
    <div class="searchList">
      <!-- 人员 -->
      <template v-if="showType === '1'">
        <div
          class="searchItem"
          v-for="(item, index) in personList"
          :key="index"
          @click="childItem(item, index)"
        >
          <div class="searchleft">
            <!-- <img :src="item.imageUrl || require('@/assets/images/moren.png')" /> -->
            <el-image
              style="height: 100%; width: 100%"
              :src="imgURL + item.imageUrl"
            >
              <template #error>
                <div class="image-slot">
                  <el-icon color="#ccc">
                    <icon-picture />
                  </el-icon>
                </div>
              </template>
            </el-image>
          </div>
          <div class="searchright">
            <!-- <div class="rightrow"><span>姓名:</span>{{ item.name }}</div>
            <div class="rightrow"><span>性别:</span>{{ item.sexDict }}</div> -->
            <div class="rightDetail">
              <span style="color: #104898">{{ item.name }}</span>
              <span>{{ item.sexDict }}</span>
            </div>
            <div class="rightrow">
              <span>证件类型:</span>{{ item.cardTypeDict }}
            </div>
            <div class="rightrow">
              <span>证件号码:</span>{{ item.cardNumber }}
            </div>
            <div class="rightrow"><span>民族:</span>{{ item.nationDict }}</div>
            <div class="rightrow">
              <span>电话号码:</span>{{ item.telphone }}
            </div>
            <!-- <div class="rightrow">
              <span>居住地址:</span>{{ item.registerDetail }}
            </div> -->
            <!-- <div class="rightrow">
              <span>电话号码:</span>{{ item.telphone }}
            </div>
            <div class="rightrow">
              <span>户籍地址:</span>{{ item.registerName }}
            </div> -->
          </div>
        </div>
      </template>
      <!-- 车辆 -->
      <template v-if="showType === '2'">
        <div
          class="searchItem"
          style="width: 327px"
          v-for="(item, index) in carList"
          :key="index"
          @click="childItem(item)"
        >
          <!-- <div class="searchleft">
             <el-button type="primary">{{item.carProvinceDict}}{{item.carNumber}}</el-button>
             <span>{{item.functionDict}}</span>
           </div> -->
          <div class="searchright carCommunity">
            <div class="rightDetail">
              <h-car-plate :type="item.carCardColor" title="">{{
                item.carProvinceDict + item.carNumber
              }}</h-car-plate>
              <!-- <h-license-plate
                :carCardColorDict="item.carColorDict"
                :plateNo="item.carProvinceDict + item.carNumber"
              ></h-license-plate> -->
              <span> {{ item.functionDict }} </span>
            </div>
            <div class="rightrow">
              <span>车辆类型:</span>{{ item.carTypeDict }}
            </div>
            <div class="rightrow">
              <span>车辆品牌:</span>{{ item.carBrandDict }}
            </div>
            <div class="rightrow">
              <span>车身颜色:</span>{{ item.carColorDict }}
            </div>
            <div class="rightrow">
              <span>机动车所有人:</span
              >{{ item.prisonInfo && item.prisonInfo.name }}
            </div>
            <div class="rightrow">
              <span>初次登记日期:</span>{{ item.createtime }}
            </div>
          </div>
        </div>
      </template>
      <!-- 房屋 -->
      <template v-if="showType === '4'">
        <div
          class="searchItem"
          v-for="(item, index) in houseList"
          :key="index"
          @click="childItem(item)"
        >
          <div class="searchleft" style="height: 100%; width: 150px">
            <el-image
              style="height: 100%; width: 100%"
              :src="imgURL + item.imageUrl"
            >
              <template #error>
                <div class="image-slot">
                  <el-icon color="#ccc">
                    <icon-picture />
                  </el-icon>
                </div>
              </template>
            </el-image>
          </div>
          <div class="searchright">
            <div class="rightrow" style="color: #104898">
              <span :title="item.houseAddress">{{ item.houseAddress }}</span>
            </div>
            <div class="rightrow">
              <span>房屋类别:</span>{{ item.houseTypeDict }}
            </div>
            <div class="rightrow">
              <span>房屋性质:</span>{{ item.housePropertyDict }}
            </div>
            <div class="rightrow">
              <span>居住现状:</span>{{ item.houseLiveDict }}
            </div>
            <div class="rightrow"><span>房主:</span>{{ item.ownerName }}</div>
          </div>
        </div>
      </template>
      <!-- 单位 -->
      <template v-if="showType === '3'">
        <div
          class="searchItem"
          v-for="(item, index) in unilList"
          :key="index"
          @click="childItem(item)"
        >
          <div class="searchleft">
            <el-image
              style="height: 100%; width: 100%"
              :src="imgURL + item.imageUrl"
            >
              <template #error>
                <div class="image-slot">
                  <el-icon color="#ccc">
                    <icon-picture />
                  </el-icon>
                </div>
              </template>
            </el-image>
          </div>
          <div class="searchright">
            <div class="rightrow">
              <span>{{ item.unitName }}</span>
              <div
                :style="{ color: item.keyunit === '0' ? 'red' : '#000' }"
                class="red"
              >
                {{ item.keyunit === "0" ? item.keyunitDict : "" }}
              </div>
            </div>
            <div class="rightrow">
              <span>单位类别: {{ item.unitTypeDict }}</span>
            </div>
            <div class="rightrow">
              <span>行业类别: {{ item.industryTypeDict }}</span>
            </div>
            <div class="rightrow">
              <span>注册地址:{{ item.registeredAddress }}</span>
            </div>
            <div class="rightrow">
              <span>单位地址:{{ item.unitAddress }}</span>
            </div>
          </div>
        </div>
      </template>
      <!-- 社区 -->
      <template v-if="showType === '5'">
        <div
          class="searchItem"
          v-for="(item, index) in eareList"
          :key="index"
          @click="childItem(item)"
        >
          <div class="searchright carCommunity">
            <div class="rightrow"><span>社区名称:</span>{{ item.name }}</div>
            <div class="rightrow">
              <span>所属街道:</span>{{ item.levelName }}
            </div>
            <div class="rightrow"><span>网格数量:</span>{{ item.gridNum }}</div>
            <div class="rightrow"><span>小区数量:</span>{{ item.plotNum }}</div>
            <div class="rightrow">
              <span>楼栋数量:</span>{{ item.buildNum }}
            </div>
            <div class="rightrow">
              <span>居民总数:</span>{{ item.communityNum }}
            </div>
          </div>
        </div>
      </template>
    </div>
    <el-pagination
      v-model:currentPage="page"
      v-model:page-size="limit"
      :page-sizes="[20, 50, 100, 200]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <filePeople
      v-if="peopleVisible"
      v-model:grandsonVisible="peopleVisible"
      :prisonId="prisonId"
      :showType="showType"
      :indexs="indexs"
    ></filePeople>

    <fileCar
      v-if="carVisible"
      v-model:grandsonVisible="carVisible"
      :prisonId="prisonId"
      :showType="showType"
    ></fileCar>

    <fileHouse
      v-if="houseVisible"
      v-model:grandsonVisible="houseVisible"
      :prisonId="prisonId"
      :showType="showType"
    ></fileHouse>

    <fileUnitl
      v-if="unitlVisible"
      v-model:grandsonVisible="unitlVisible"
      :prisonId="prisonId"
      :showType="showType"
    ></fileUnitl>

    <fileCommunity
      v-if="communityVisible"
      v-model:grandsonVisible="communityVisible"
      :prisonId="prisonId"
      :showType="showType"
    ></fileCommunity>
  </el-card>
</template>
<script>
import { defineComponent, reactive, toRefs, watchEffect, watch } from "vue";
import { queryUserList } from "@/api/realPopulation/realPopulation";
import {
  houseList,
  leftListquery,
  unitList,
  carlist,
} from "@/api/threeSolid/fileManagement";
import fileCar from "./fileCar";
import filePeople from "./filePeople";
import fileHouse from "./fileHouse";
import fileUnitl from "./fileUnitl";
import { Picture as IconPicture } from "@element-plus/icons-vue";
import fileCommunity from "./fileCommunity";
export default defineComponent({
  name: "",
  components: {
    fileCar,
    filePeople,
    fileCommunity,
    fileHouse,
    fileUnitl,
    IconPicture,
  },
  props: {
    searchVisible: {
      type: Boolean,
    },
    tableParams: {
      type: Object,
    },
  },
  setup(props, context) {
    const data = reactive({
      imgURL: window.imgURL,
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      indexs: "",
      sonVisible: false, // 控制本页面显示隐藏
      personList: [], // 人员
      carList: [], // 车辆
      houseList: [], // 房屋
      unilList: [], // 单位
      eareList: [], // 区域
      showType: "",
      modelItem: {},
      peopleVisible: false, // 人
      carVisible: false, // 车
      unitlVisible: false, //
      houseVisible: false, //
      communityVisible: false, //
      limit: 20,
      page: 0,
      total: 0,
      prisonId: 0,
    });
    const refData = toRefs(data);

    watch(
      () => props.searchVisible,
      (v) => {
        // person();
        data.sonVisible = v;
        if (v) {
          person(1);
        }
      },
      { immediate: true }
    );
    watch(
      () => props.tableParams.type,
      (v) => {
        data.showType = v;
      }
    );
    // 监听
    watch(
      () => props.tableParams,
      (v) => {
        // person();
      },
      { deep: true }
    );
    watchEffect(() => {
      context.emit("update:searchVisible", data.sonVisible);
    });
    const person = async (type) => {
      if (type === 1) {
        data.page = 1;
      }
      const parms = {
        search: props.tableParams.search,
        page: data.page,
        limit: data.limit,
      };
      if (data.showType === "1") {
        const res = await queryUserList(parms);
        data.personList = res.page.list;
        data.total = res.page.totalCount;
      } else if (data.showType === "2") {
        const car = await carlist(parms);
        data.carList = car.page.list;
        data.total = car.page.totalCount;
      } else if (data.showType === "3") {
        const unitl = await unitList(parms);
        data.unilList = unitl.page.list;
        data.total = unitl.page.totalCount;
      } else if (data.showType === "4") {
        const house = await houseList(parms);
        data.houseList = house.page.list;
        data.total = house.page.totalCount;
      } else if (data.showType === "5") {
        const parms = {
          search: props.tableParams.search,
          type: "1",
          page: data.page,
          limit: data.limit,
          total: data.total,
        };
        const eare = await leftListquery(parms);
        data.eareList = eare.page.list;
        data.total = eare.page.totalCount;
      }
    };

    const backsearch = () => {
      data.sonVisible = false;
    };
    // 1人员档案 2车辆,3单位,4房屋,5社区
    const childItem = (item, index) => {
      if (index) {
        data.indexs = index;
      }
      data.modelItem = item;
      console.log(item);
      if (data.showType === "1") {
        data.peopleVisible = true;
        data.prisonId = item.prisonId;
      } else if (data.showType === "2") {
        data.carVisible = true;
        data.prisonId = item.carId;
      } else if (data.showType === "3") {
        data.unitlVisible = true;
        data.prisonId = item.unitId;
      } else if (data.showType === "4") {
        data.houseVisible = true;
        data.prisonId = item.houseId;
        console.log(data.prisonId);
      } else if (data.showType === "5") {
        data.communityVisible = true;
        data.prisonId = item.regionId;
      }
    };
    const handleCurrentChange = (item) => {
      data.page = item;
      person();
    };
    const handleSizeChange = (item) => {
      data.limit = item;
      person();
    };
    return {
      ...refData,
      backsearch,
      childItem,
      handleCurrentChange,
      handleSizeChange,
    };
  },
});
</script>
<style lang="scss" scoped>
.filesearchList {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  color: #000;
  display: flex;
  flex-direction: column;
  .topBox {
    line-height: 15px;
    border-bottom: 1px solid #f1f2f5;
    padding: 0 20px;
  }
  .searchList {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    overflow: auto;
    .searchItem {
      width: 436px;
      // height: 200px;
      border: 1px solid #f1f2f5;
      display: flex;
      border-radius: 4px;
      margin: 10px;
      line-height: 30px;
      padding: 10px;
      cursor: pointer;
      &:hover {
        transform: translate(0, -6px);
        box-shadow: 0 5px 10px 0 #f0f0f0;
        transition: box-shadow 0.5s, transform 0.5s;
        border-color: #5584ff;
        // .label-title {
        //   background: #5584ff;
        //   color: #fff;
        // }
      }
      .searchleft {
        width: 160px;
        height: 150px;
        margin-right: 20px;
        text-align: center;
        display: flex;
        flex-direction: column;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .searchright {
        // flex: 1;
        width: 60%;
        &.carCommunity {
          width: 100%;
        }
      }

      .rightrow {
        display: flex;
        position: relative;
        height: 16%;
        span {
          margin-right: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        // span:nth-child(1) {
        //   width: 90px;
        // }
        span:nth-child(2) {
          // margin-left: 20px;
        }
      }
      .rightDetail {
        display: flex;
        justify-content: space-between;
        line-height: 40px;
      }
    }
  }
  .red {
    color: #f00;
    position: absolute;
    right: 0;
  }
  .image-slot {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f7fa;
  }
}
.layout-main-page-box {
  background: red !important;
  // z-index: 1000;
}
</style>
